/**
 * PhoneOutlineIcon — auto-generated by scripts/generate-icons.ts.
 * Do NOT edit manually — re-run `yarn codegen:icons` to regenerate.
 */

// SVGProps is used by the SVGR-generated component below.
import type { SVGProps } from 'react'
import { makeIcon } from '../make-icon'

interface SVGRProps {
  title?: string
  titleId?: string
}
const PhoneOutlineIconSvg = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule="evenodd"
      d="M4.756 3.78a2.75 2.75 0 0 1 3.888 0l1.174 1.173c.85.85.855 2.155.08 3.086l-.165.181-.82.818q-.001.003-.004.005a11.9 11.9 0 0 0 2.478 3.57 11.9 11.9 0 0 0 3.568 2.478l.007-.004.902-.903a2.25 2.25 0 0 1 3.183-.001l1.173 1.174a2.75 2.75 0 0 1 0 3.888l-.652.65c-.927.928-2.25 1.3-3.539 1.058-2.78-.526-5.774-2.127-8.314-4.667-2.382-2.382-3.939-5.162-4.557-7.792l-.111-.523c-.243-1.288.13-2.613 1.056-3.54zm2.828 1.06a1.25 1.25 0 0 0-1.768 0l-.652.652c-.555.556-.8 1.37-.643 2.2.463 2.445 1.897 5.174 4.254 7.532 2.358 2.358 5.088 3.793 7.533 4.255.83.157 1.645-.089 2.2-.644l.651-.651a1.25 1.25 0 0 0 0-1.767l-1.174-1.173a.75.75 0 0 0-1.003-.052l-.056.051-.904.905a1.5 1.5 0 0 1-1.55.365l-.11-.043a13.4 13.4 0 0 1-4.036-2.796 13.4 13.4 0 0 1-2.794-4.037 1.5 1.5 0 0 1 .321-1.66l.82-.818.07-.077c.327-.387.264-.818.015-1.068z"
      clipRule="evenodd"
    />
  </svg>
)

/** @see {@link https://design.reapit.com.au} Reapit DS icon */
export const PhoneOutlineIcon = makeIcon('PhoneOutlineIcon', PhoneOutlineIconSvg)
